import { Loader as TetrisLoader, Typography } from '@pocketlaw/tetris';
import { LoaderContainer } from './styled';
export function Loader(props) {
    const { message } = props;
    return (<LoaderContainer>
      <TetrisLoader size={12}/>
      <Typography>{message}</Typography>
    </LoaderContainer>);
}
